import type { en } from "./en.ts";

export const fr: typeof en = {
    Routines: {
        list: {
            heading: "Routines de l'organisation",
            description: "Exécutions récurrentes que votre organisation publie à son audience. Chaque routine invoque une compétence.",
            newAutomation: "Nouvelle routine",
            loading: "Chargement des routines",
            tryNow: "Essayer maintenant",
            edit: "Modifier",
            delete: "Supprimer",
            label: "{{skill}} · {{audience}}",
            skillWithTemplate: "{{skill}} · {{template}}",
            default: "Par défaut",
            rowMenu: "Actions pour {{name}}"
        },
        received: {
            heading: "Routines que vous recevez",
            description: "Votre organisation les exécute pour vous. Désactivez-en une pour ne plus la recevoir.",
            empty: "Aucune routine de l'agent ne vous est transmise pour l'instant."
        },
        mute: {
            turnOff: "Désactiver",
            turnBackOn: "Réactiver",
            turnedOff: "Désactivée. Vous ne la recevez plus.",
            turnedBackOn: "Réactivée. Vous la recevez de nouveau."
        },
        organization: {
            turnOff: "Désactiver pour l'organisation",
            turnOn: "Activer pour l'organisation",
            turnedOn: "Activée pour l'organisation.",
            turnedOff: "Désactivée pour l'organisation.",
            confirmTitle: "Désactiver pour l'organisation?",
            confirmDescription: "Personne dans son audience ne la reçoit tant que vous ne la réactivez pas. Les personnes qui l'ont désactivée pour elles-mêmes conservent ce choix.",
            confirm: "Désactiver"
        },
        loadError: {
            title: "Impossible de charger les routines",
            retry: "Réessayer"
        },
        columns: { automation: "Routine", trigger: "Déclencheur", skill: "Compétence", audience: "Audience", status: "Statut", actions: "Actions" },
        firstRoutine: {
            schedule: "Chaque lundi, 8 h",
            steps: { skill: "Choisir une compétence", schedule: "Fixer un horaire", audience: "Joindre une audience" },
            benefit: "Une routine exécute une compétence selon un horaire pour toute son audience, et chaque personne reçoit le résultat sans avoir à le demander."
        },
        deletedToast: "Routine supprimée.",
        delete: {
            title: "Supprimer {{name}}?",
            description: "Son audience ne la recevra plus. Cette action est irréversible.",
            confirm: "Supprimer",
            error: "Impossible de supprimer la routine. Réessayez."
        },
        create: {
            created: "Routine créée.",
            error: "Impossible de créer la routine. Réessayez."
        },
        form: {
            skill: "Compétence",
            template: "Modèle",
            templateDefault: "Par défaut",
            audience: "Audience",
            cadenceManagedDefault: "Toujours hebdomadaire pour la routine par défaut",
            audienceManagedDefault: "Gérée pour tous les gestionnaires",
            audienceEveryone: "Envoyée à tout le monde dans l'organisation",
            audienceUnchangeable: "Cette audience ne peut pas être modifiée ici",
            cadence: "Fréquence",
            day: "Envoyer le",
            deliveryNote: "Livré à chaque destinataire par son canal de notification.",
            submit: "Créer la routine",
            cancel: "Annuler"
        },
        edit: {
            title: "Modifier la routine",
            submit: "Enregistrer",
            saved: "Routine mise à jour.",
            error: "Impossible d'enregistrer la routine. Réessayez."
        },
        result: {
            title: "Aperçu : {{skill}}",
            close: "Fermer",
            composing: "Workleap Agent exécute {{skill}}…",
            failed: "L'exécution a échoué. Réessayez.",
            empty: "Rien à afficher pour l'instant",
            emptyDescription: "La compétence n'a rien trouvé à vous signaler pour le moment.",
            opensInNewTab: "s'ouvre dans un nouvel onglet"
        },
        role: { managers: "Gestionnaires", executives: "Direction" },
        audienceValue: { everyone: "Tout le monde" },
        status: { active: "Active", paused: "En pause", off: "Désactivée" },
        cadence: { weekly: "Hebdomadaire", biweekly: "Toutes les deux semaines", monthly: "Mensuelle" },
        trigger: { weekly: "Chaque {{day}}", biweekly: "Un {{day}} sur deux", monthly: "Chaque mois" },
        day: { monday: "lundi", tuesday: "mardi", wednesday: "mercredi", thursday: "jeudi", friday: "vendredi", saturday: "samedi", sunday: "dimanche" },
        skillName: {
            wai_weekly_brief: "Bilan hebdomadaire",
            wov_engagement_report: "Rapport Pulse",
            wov_help_me_reply_to_feedback: "M'aider à répondre au feedback",
            wpm_review: "Évaluation de performance",
            wai_people_about: "À propos d'une personne",
            draft_a_plan: "Rédiger un plan",
            wov_summarize_feedback: "Résumer le feedback",
            wov_feedback_export: "Exporter le rapport de feedback",
            wov_analyze_engagement: "Analyser l'engagement",
            wov_export_engagement: "Exporter le rapport d'engagement"
        }
    }
};
